import React, { useEffect } from "react";
import {
  Button,
  Col,
  Flex,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Typography,
} from "antd";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Ads.module.scss";
import { updateSponsorAction } from "../../../../../../redux/services/ads-and-addons-services/adsAndAddonsServices";
import { sanitizeDataTypeClientSide } from "../../../../../../utils/utils";
import { allowCharactersOnlyForDecimalNumbers, allowCharactersOnlyForIntegerNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
import { getSystemSettingsAction } from "../../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import { useNavigate } from "react-router-dom";
import { baseRouteMakerForSuperAdmin, routes } from "../../../../../../constants/routeConsts";

const Ads = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch dependencies */
  const dispatch = useDispatch();
  /* dispatch dependencies */

  const navigate = useNavigate();

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const initialValues = {
    type: null,
    price:"",
    duration: null
  };
  const { systemSettings } = useSelector((state) => state.addonAndSponsorship);
  /* form dependencies */

  useEffect(()=>{
    dispatch(getSystemSettingsAction(setLoading));
  },[])

  /* on Category changed */
  const onCategoryChanged = () => {};
  /* on Category changed */

  /* reset default form fields */
  const resetDefaultFields = () => {
    form.setFieldsValue({
      price: initialValues.price,
      duration: initialValues.duration
    });
  }
  /* reset default form fields */

  const handleViewList = () => {
    navigate(baseRouteMakerForSuperAdmin(routes.ADS_LIST))
  }

  const onSubmit = (values) => {
    const {price, ...rest} = values;
    const dataToBeSent = {...rest,price:Number(price), duration_unit:"month", currency: systemSettings?.system_currency}
    dispatch(updateSponsorAction(dataToBeSent))
    resetDefaultFields()
  };

  return (
    <div className={styles.adsContainer}>
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        requiredMark={false}
        onFinish={onSubmit}
        initialValues={initialValues}
      >
        <Row gutter={[24, 24]}>
          <Col span={22}>
            <Form.Item
              name="type"
              label={
                <RequiredLabel
                  text={t("Modules.Ads.sponsored")}
                  required={true}
                />
              }
              rules={[
                {
                  required: true,
                  message: t("Modules.Ads.pleaseSelectSponsored"),
                },
              ]}
            >
              <Radio.Group>
                <Radio value="offer">{t("Modules.Ads.offer")}</Radio>
                <Radio value="package">{t("Modules.Ads.packages")}</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={2}>
          <Button
              type="primary"
              loading={loading}
              disabled={loading}
              style={{ marginTop: "10px" }}
              onClick={(e) => handleViewList(e)}
            >
              {t("CommonUtils.logs")}
            </Button>
          </Col>
          <Col span={8}>
            <Form.Item
              label={
                <RequiredLabel
                  text={t("Modules.Services.ServicesForm.price")}
                  required={true}
                />
              }
              name="price"
              rules={[
                {
                  required: true,
                  message: t("Modules.Services.ServicesForm.pleaseEnterPrice"),
                },
                {
                  validator:(_, value) => {
                    if(value && value < 1) return Promise.reject(`${t("Modules.Services.ServicesForm.price")} ${t("CommonUtils.shouldBeGreaterThan0")}`);
                    return Promise.resolve();
                  }
                }
              ]}
            >
              <Input
                type="number"
                placeholder={t("Modules.Services.ServicesForm.enterPrice")}
                onKeyDown={(e)=>allowCharactersOnlyForDecimalNumbers(e)}
                onWheel={(e) => e.currentTarget.blur()}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="duration"
              label={<RequiredLabel text={t("Modules.Ads.period")} required={true} />}
              rules={[{required: true, message: t("Modules.Ads.pleaseSelectPeriod")}]}
            >
              <Select
                loading={selectListLoader}
                options={[
                  { value: 1, label: "01 month" },
                  { value: 4, label: "04 months" },
                  { value: 6, label: "06 months" },
                  { value: 12, label: "12 months" }
                ]}
                placeholder={t("Modules.Ads.selectPeriod")}
              />
            </Form.Item>
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={loading}
              style={{ marginTop: "10px" }}
            >
              {t("CommonUtils.submit")}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Ads;
